import { actionMenuStrings } from '../data/static/strings'
import {
  dateFormatter,
  DateFormatTypes,
  fromDateTime,
  getDifferenceFromEndStartDateTime,
  getStartDateFromDifference,
  getYesterday,
  roundOfToTwoDigits,
  toDateTime,
} from './util'

export const getInsightSummeryDateTimeRoundOff = (req: any, selectedDateInfo: any) => {
  if (req && req.inputFilter) {
    const difference = getDifferenceFromEndStartDateTime(req.inputFilter.endDateTime, req.inputFilter.startDateTime)
    let updatedRequest = req
    const currentDate = new Date()
    //req.inputFilter.endDateTime = '2023-02-11 23:59:59'
    const endDateTime = req.inputFilter.endDateTime
    if (
      selectedDateInfo &&
      selectedDateInfo?.dateLabel === actionMenuStrings.yesterday &&
      endDateTime &&
      endDateTime.length > 0
    ) {
      /* // TODO: if yesterday selected then endDate not required to update currentDate.
      Update only the yesterday Start and End date-time */
      try {
        const endDate = endDateTime.split(' ')[0]
        const endDateArr = endDate.split('-')
        const getLastDay = getYesterday('END')
        if (endDateArr.length && new Date(endDateTime)?.getDate() !== getLastDay?.getDate()) {
          const yesterday = getYesterday('START')
          updatedRequest.inputFilter.endDateTime = `${getLastDay.getFullYear()}-${roundOfToTwoDigits(
            getLastDay.getMonth() + 1,
          )}-${roundOfToTwoDigits(getLastDay.getDate())}`
          updatedRequest.inputFilter.startDateTime = `${yesterday.getFullYear()}-${roundOfToTwoDigits(
            yesterday.getMonth() + 1,
          )}-${roundOfToTwoDigits(yesterday.getDate())}`
        }
      } catch (error) {
        console.log('failed to get end date and time')
      }
    } else if (endDateTime && endDateTime.length > 0) {
      const endDate = endDateTime.split(' ')[0]
      let updatedDate = endDate
      if (endDate.includes('-')) {
        const endDateArr = endDate.split('-')
        if (endDateArr[0] && endDateArr[1] && endDateArr[2]) {
          if (
            !(
              currentDate.getFullYear() === +endDateArr[0] &&
              currentDate.getMonth() + 1 === +endDateArr[1] &&
              currentDate.getDate() === +endDateArr[2]
            )
          ) {
            updatedDate = `${currentDate.getFullYear()}-${roundOfToTwoDigits(
              currentDate.getMonth() + 1,
            )}-${roundOfToTwoDigits(currentDate.getDate())}`
          }
        }
      }
      // Update endTime if it does not equal 23:59:59
      updatedRequest.inputFilter.endDateTime = `${updatedDate}`
      //Check and update startDateTime
      const startDateTime = req.inputFilter.startDateTime
      if (startDateTime && startDateTime.length > 0) {
        //  update startTime only if it not includes 00:00:00 && 23:59:59
        //if (!startDateTime.includes('00:00:00') && !startDateTime.includes('23:59:59')) {
        const sDate = getStartDateFromDifference(updatedRequest.inputFilter.endDateTime, difference)
        let updatedStartDateTime = new Date(sDate)
        updatedRequest.inputFilter.startDateTime = `${updatedStartDateTime.getFullYear()}-${roundOfToTwoDigits(
          updatedStartDateTime.getMonth() + 1,
        )}-${roundOfToTwoDigits(updatedStartDateTime.getDate())}`
        //}
      }
    }
    return updatedRequest
  } else {
    return req
  }
}

export const roundOffFromDateAndToDate = (req: any, selectedDateInfo: any) => {
  const updatedRequest = { ...req }
  const difference = getDifferenceFromEndStartDateTime(req.toDate, req.fromDate, true)
  //req.toDate = new Date('2023-02-13 23:59:57')
  const currentDate = new Date()
  const endDateTime = new Date(req.toDate)
  if (selectedDateInfo && selectedDateInfo?.dateLabel === actionMenuStrings.yesterday && endDateTime) {
    try {
      const getLastDay = getYesterday('END')
      if (new Date(endDateTime)?.getDate() !== getLastDay?.getDate()) {
        updatedRequest.toDate = getLastDay
        updatedRequest.fromDate = getYesterday('START')
      }
    } catch (error) {
      console.log('failed to get end date and time')
    }
  } else if (endDateTime) {
    //if (endDateTime.includes(' ')) {
    const endDate = toDateTime(endDateTime)
    let updatedDate = new Date(endDate)
    const endDateArr = endDate.split('-')
    if (endDateArr.length && endDateArr[0] && endDateArr[1] && endDateArr[2]) {
      if (
        !(
          currentDate.getFullYear() === +endDateArr[0] &&
          currentDate.getMonth() + 1 === +endDateArr[1] &&
          currentDate.getDate() === +endDateArr[2]
        )
      ) {
        updatedDate = currentDate
      }
    }
    updatedRequest.toDate = updatedDate
    if (req.fromDate) {
      const startDateTime = fromDateTime(endDateTime)
      //  update startTime only if it not includes 00:00:00 && 23:59:59
      if (!startDateTime.includes('00:00:00') && !startDateTime.includes('23:59:59')) {
        const sDate = getStartDateFromDifference(updatedRequest.toDate, difference, true)
        updatedRequest.fromDate = new Date(sDate)
      }
    }
    //}
  }
  return updatedRequest
}

export const roundOffCampaignFromDateAndToDate = (req: any, selectedDateInfo: any) => {
  if (req && req.filter) {
    const difference = getDifferenceFromEndStartDateTime(req.filter.endDate, req.filter.startDate)
    let updatedRequest = req
    const currentDate = new Date()
    //req.filter.endDate = new Date('2023-02-11')
    const endDateTime = req.filter.endDate
    if (
      selectedDateInfo &&
      selectedDateInfo?.dateLabel === actionMenuStrings.yesterday &&
      endDateTime &&
      endDateTime.length > 0
    ) {
      try {
        const getLastDay = getYesterday('END')
        if (new Date(endDateTime)?.getDate() !== getLastDay?.getDate()) {
          updatedRequest.filter.endDate = dateFormatter(getLastDay, DateFormatTypes.DATE_HYPHEN)
          updatedRequest.filter.startDate = dateFormatter(getYesterday('START'), DateFormatTypes.DATE_HYPHEN)
        }
      } catch (error) {
        console.log('failed to get end date and time')
      }
    } else if (endDateTime && endDateTime.length > 0) {
      const endDate = endDateTime.split(' ')[0]
      let updatedDate = new Date(endDate)
      if (endDate.includes('-')) {
        const endDateArr = endDate.split('-')
        if (endDateArr[0] && endDateArr[1] && endDateArr[2]) {
          if (
            !(
              currentDate.getFullYear() === +endDateArr[0] &&
              currentDate.getMonth() + 1 === +endDateArr[1] &&
              currentDate.getDate() === +endDateArr[2]
            )
          ) {
            updatedDate = currentDate
          }
        }
      }
      // Update endTime if it does not equal 23:59:59
      updatedRequest.filter.endDate = dateFormatter(updatedDate, DateFormatTypes.DATE_HYPHEN)
      //Check and update startDateTime
      const startDateTime = req.filter.startDate
      if (startDateTime && !startDateTime.includes('00:00:00') && !startDateTime.includes('23:59:59')) {
        const sDate = getStartDateFromDifference(updatedRequest.filter.endDate, difference)
        let updatedStartDateTime = new Date(sDate)
        updatedRequest.filter.startDate = dateFormatter(updatedStartDateTime, DateFormatTypes.DATE_HYPHEN)
      }
    }
    return updatedRequest
  } else {
    return req
  }
}
